import { render } from "./OvertimeRequest.vue?vue&type=template&id=2f2be60a&scoped=true"
import script from "./OvertimeRequest.vue?vue&type=script&lang=js"
export * from "./OvertimeRequest.vue?vue&type=script&lang=js"

import "./OvertimeRequest.vue?vue&type=style&index=0&id=2f2be60a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f2be60a"]])

export default __exports__